import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ADPLATMFORM_MAP } from './PromotedObjectSelect';

// 推广目标展示组件

class PromotedObjectInfo extends React.Component {
  static propTypes = {
    // webApi: PropTypes.object.isRequired,
    promotedObjectRepo: PropTypes.object.isRequired,
    promotedObject: PropTypes.shape({
      adPlatformType: PropTypes.string,
      promotedObject: PropTypes.string,
    }),
  }
  //
  // componentDidMount() {
  //   const {webApi, promotedObjectRepo} = this.props;
  //   if (_.isEmpty(promotedObjectRepo)) {
  //     webApi.getPromotedObjectList().dispatch(ActionTypes.FETCH_PROMOTED_OBJECT_LIST);
  //   }
  // }

  render() {
    const { promotedObject, promotedObjectRepo } = this.props;

    if (!promotedObject) {
      return null;
    }

    const {
      adPlatformTypes,
      adPlatformType,
    } = promotedObject;

    // promotedObject 拿到的是 intention 字段

    // const adPlatform = promotedObjectRepo[promotedObject.adPlatformType]
    // if (adPlatform) {
    // const option = adPlatform[promotedObject.promotedObject]
    // 展示两级
    // return (
    //   <span className="PromotedObjectInfo">
    //     {ADPLATMFORM_MAP[promotedObject.adPlatformType]}
    //     {/* {getMessage(promotedObject.adPlatformType, "AdPlatformType")} */}
    //     {option || promotedObject.promotedObject ? " - " + (option || promotedObject.promotedObject) : ""}
    //   </span>
    // )
    // }
    // 只展示一级
    let id = adPlatformTypes || adPlatformType;
    let data = '';

    if (Array.isArray(id)) {
      data = id.map((item) => ADPLATMFORM_MAP[item]).join(',');
    } else {
      data = ADPLATMFORM_MAP[id];
    }

    return (
      <span className="PromotedObjectInfo">
        {data || '-'}
      </span>
    );

    // return <span className="PromotedObjectInfo">{promotedObject.promotedObject ? "未知推广目标" : "-"}</span>
  }
}

function mapStateToProps(state, ownProp) {
  return {
    promotedObjectRepo: state.promotedObjectRepo,
  }
}

export default connect(mapStateToProps)(PromotedObjectInfo)
